import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import TenantAuditDetail from './TenantAuditDetail';
import { Container } from 'reactstrap';

const TenantAudit = () => {
    // Same rule as the sidebar: user group has Access Audit and the concessionaire has audit enabled
    if (localStorage.getItem("accessAudit") !== "1" || localStorage.getItem("auditRequired") !== "true") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
        return null;
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Audit" title="Tenant Audit Detail" mainTitle="Tenant Audit Detail" />
                <Container fluid={true}>
                    <TenantAuditDetail />
                </Container>
            </Fragment>
        </UL>
    )
}

export default TenantAudit